module.exports = __webpack_public_path__ + "images/corporate_buybacks_lp/icon_form_a3ece453a9a70474383e4511f74d95d1.png";